'use client';
import cn from 'classnames';
import styles from './FilterButton.module.scss';

type FilterButtonProps = {
  className?: string;
  activeCount: number;
  onClick: () => void;
};

export function FilterButton({
  className,
  activeCount,
  onClick,
}: FilterButtonProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName} onClick={onClick}>
      <img src="/svg/filters.svg" alt="filters" className={styles.icon} />
      <span className={styles.text}>Фильтры</span>
      {activeCount > 0 && <span className={styles.count}>{activeCount}</span>}
    </div>
  );
}
